<template>
  <div>
    <!-- header -->
    <div class="header">
      <div class="header-info">
        <span v-if="showSum">
          物品信息：物品数量 {{ numSum }} 。 金额合计 {{tool.money_format_allowvoid(moneySum)}} 。
        </span>
        <span v-if="showOnlySum"> 物品信息：物品数量 {{ numSum }} 。 </span>
      </div>

      <el-button v-if="editable" type="primary" plain round @click="addBatch"
        >批量选择</el-button
      >
    </div>
    <!-- table -->
    <el-table
      ref="table"
      style="width: 100%"
      :border="true"
      :data="data"
      highlight-current-row
      v-loading="dialogLoading"
    >
      <template v-for="(item, index) in columnsShow">
        <el-table-column
          v-if="item.prop == 'name'"
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.inputFlag"
              v-model="currentId"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @change="handleSelectChange"
              :loading="tableLoading"
            >
              <el-option
                v-for="item in list"
                :key="item.consumableId"
                :label="item.name"
                :value="item.consumableId"
              >
              </el-option>
            </el-select>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.prop == numberKey && numberMode == 'input'"
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
          <template v-if="scope.row.consumableId" slot-scope="scope">
            <el-input
              v-model="scope.row[numberKey]"
              :class="{ errorBorder: scope.row.error }"
              @input="inputNumChange(scope.row)"
            >
            </el-input>
            <div v-if="scope.row.error" class="errorText">
              {{ scope.row.errorMessage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.prop == priceKey && priceMode == 'input'"
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
          <template v-if="scope.row.consumableId" slot-scope="scope">
            <moneyInput v-model="scope.row[priceKey]" placeholder="请输入金额"  :template="'no'" style="width: 100%" :class="{ errorBorder: scope.row.error2 }" />
            <!-- <el-input
              v-model="scope.row[priceKey]"
              :class="{ errorBorder: scope.row.error2 }"
              @input="inputPriceChange(scope.row)"
            >
            
            </el-input> -->
            <div v-if="scope.row.error2" class="errorText">
              {{ scope.row.error2Message }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.prop == priceKey && priceMode != 'input'"
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
          <template v-if="scope.row.consumableId" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row[item.prop])  }}</span></div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.prop == 'rowSum' ||item.prop == 'priceOutboundNum'"
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
          <template slot-scope="scope">
             <div class="money"><span>{{tool.money_format_allowvoid(scope.row[item.prop])  }}</span></div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          :type="item.type || ''"
          :width="item.width || 'auto'"
          :label="item.label"
          :prop="item.prop"
          :align="item.align || 'center'"
        >
        <!-- <template slot-scope="scope">
              {{scope.row[item.prop] }}
          </template> -->
        </el-table-column>
        
      </template>
      <el-table-column
        v-if="editable"
        fixed="right"
        label="操作"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="del(scope.row)"
            >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- add -->
    <div class="add" v-if="editable" @click="addOne">+ 新增</div>
    <!-- dialog -->
    <el-dialog
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="70%"
      title="添加"
      append-to-body
      :close-on-click-modal="false"
    >
      <avue-crud
        ref="crud"
        :data="list"
        :option="option"
        :page.sync="page"
        :table-loading="tableLoading"
        @current-change="currentChange"
        @size-change="sizeChange"
        @selection-change="selectionChange"
      >
        <template slot="menuLeft">
          <div style="height: 38px; line-height: 38px">
            已选物品（{{ choosenList.length }}）
          </div>
        </template>
        <template slot="menuRight">
          <el-form inline>
            <el-form-item>
              <el-select
                v-model="query.typeName"
                ref="categorySelect"
                placeholder="物品类型"
              >
                <el-option>
                  <el-tree
                    ref="categoryTree"
                    :props="props"
                    :load="loadNode"
                    node-key="name"
                    check-strictly
                    lazy
                    check-on-click-node
                    :expand-on-click-node="false"
                    @node-click="nodeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="query.text" placeholder="物品名称/编号">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search"
                >搜索</el-button
              >
              <el-button plain icon="el-icon-delete" @click="clearSearch"
                >清除</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </avue-crud>
      <div class="crud-submit">
        <el-button type="primary" size="small" @click="crudSubmit"
          >提交</el-button
        >
        <el-button size="small" @click="crudCancel">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { typeLazyTree } from "@/api/crmedical/warehouse/index.js";
export default {
  props: {
    showOnlySum: {
      type: Boolean,
      default: false,
    },
    priceMode: {
      //normal,input,dynamic
      default: "normal",
    },
    numberMode: {
      //mormal,input
      default: "normal",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    showSum: {
      type: Boolean,
      default: false,
    },
    numberKey: {
      type: String,
      default: "inboundNum",
    },
    priceKey: {
      type: String,
      default: "price",
    },
    priceValidate: {
      default: true,
    },
    projectId: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => {
        return [
          { label: "序号", prop: "", type: "index", width: 50 },
          { label: "物品", prop: "name" },
          { label: "编号", prop: "code" },
          { label: "类型", prop: "typeName" },
          { label: "品牌", prop: "brand" },
          { label: "规格", prop: "specification" },
          { label: "生产商", prop: "manufacturer" },
          { label: "计量单位", prop: "measuringUnitName" },
          { label: "数量", prop: "inboundNum" },
          { label: "单价", prop: "price" },
          { label: "小计", prop: "rowSum" },
          { label: "库存", prop: "stockNum" },
          {
            label: "可出库数量",
            prop: "surplus",
            maxCheck: true,
            hide: true,
          },
        ];
      },
    },
  },
  data() {
    return {
      timer: "",
      ignoreNumZero: false,
      ignorePriceZero: false,
      dialogVisible: false,
      tableLoading: false,
      dialogLoading: false,
      currentId: "",
      munSum: "",
      moneySum: "",
      columnsMaxCheck: [],
      columnsShow: [],
      list: [],
      choosenList: [],
      option: {
        selection: true,
        selectionWidth: 50,
        selectionFixed: false,
        border: true,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        align: "center",
        menu: false,
        menuFixed: false,
        menuAlign: "center",
        column: [
          { label: "分类", prop: "typeName" },
          { label: "编号", prop: "code" },
          { label: "名称", prop: "name" },
          { label: "计量单位", prop: "measuringUnitName" },
          { label: "品牌", prop: "brand" },
          { label: "规格", prop: "specification" },
        ],
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 40, 50, 100],
        layout: "total,pager,prev,next",
        background: false,
      },
      //分类树props
      props: {
        label: "name",
        children: "children",
        isLeaf: "isLeaf",
        disabled: "disabled",
      },
      //搜索条件
      query: {
        name: "",
        typeId: "",
        text: "",
      },
    };
  },
  created() {
    //获取需要 maxCheck的值
    this.columnsMaxCheck = this.columns.filter((ele) => ele.maxCheck);
    //过滤隐藏的值
    this.columnsShow = this.columns.filter((ele) => !ele.hide);
    //输入价格和数量 0值是否需要判断
    this.columns.forEach((ele) => {
      if (ele.prop == this.numberKey && ele.ignoreZero == true) {
        this.ignoreNumZero = true;
      }
      if (ele.prop == this.priceKey && ele.ignoreZero == true) {
        this.ignorePriceZero = true;
      }
    });
    this.calcSums();
  },
  methods: {
    remoteMethod(val) {
      this.query.text = val;
      if (val) {
        this.loadData("single");
      } else {
        this.list = [];
      }
    },
    validate() {
      this.removeEmptyRow();
      let validatePass = true;
      this.data.forEach((row) => {
        //校验数字
        let val = row[this.numberKey];
        row.error = false;
        row.errorMessage = "";
        row.error2 = false;
        row.error2Message = "";
        if (!/^[1-9]\d{0,7}$/.test(val)) {
          //0值检查
          if (!(this.ignoreNumZero && val == "0")) {
            row.error = true;
            row.errorMessage = "请输入正整数";
          }
        } else {
          console.log("this.columnsMaxCheck==>", this.columnsMaxCheck);
          let maxFlag = false;
          //maxcheck
          if (this.columnsMaxCheck.length > 0) {
            this.columnsMaxCheck.forEach((ele) => {
              if (val > row[ele.prop]) {
                maxFlag = true;
                row.errorMessage = `输入值不能大于 ${ele.label}`;
              }
            });
          }
          row.error = maxFlag;
        }
        if (row.error) validatePass = false;
        //校验金额
        if (this.priceValidate) {
          if (
            !/^[1-9]\d{0,9}(\.\d{1,2})?$|^0\.\d{1,2}$/.test(row[this.priceKey])
          ) {
            //0值检查
            if (!(this.ignorePriceZero && row[this.priceKey] == "0")) {
              validatePass = false;
              row.error2 = true;
              row.error2Message = "请输入正确的金额（最多2位小数）";
            }
          }
        }
      });
      this.data = Object.assign([], this.data);
      return validatePass;
    },
    removeEmptyRow() {
      this.data.forEach((ele, index) => {
        if (!ele.consumableId) {
          this.data.splice(index, 1);
        }
      });
    },
    inputNumChange(row) {
      this.removeEmptyRow();
      let self = this;
      let val = row[this.numberKey];
      row.error = false;
      row.errorMessage = "";
      if (!/^[1-9]\d{0,7}$/.test(val)) {
        console.log("2==>", 2);
        if (!(this.ignoreNumZero && val == "0")) {
          row.error = true;
          row.errorMessage = "请输入正整数";
        }
      } else {
        console.log("3==>", 3);
        console.log("this.columnsMaxCheck==>", this.columnsMaxCheck.length);
        let maxFlag = false;
        if (this.columnsMaxCheck.length > 0) {
          this.columnsMaxCheck.forEach((ele) => {
            if (row[ele.prop] && Number(val) > Number(row[ele.prop])) {
              maxFlag = true;
              row.errorMessage = `输入值不能大于" ${ele.label} "`;
            }
          });
        }
        row.error = maxFlag;
      }
      row[this.numberKey] = val.slice(0, 7); //限制大小
      //
      if (row.error || this.priceMode != "dynamic" || val == 0) {
        this.calcSums();
        return;
      }
      this.data = Object.assign([], this.data);
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.dialogLoading = true;
        try {
          this.$emit(
            "loadPrice",
            { consumableId: row.consumableId, outboundNum: val },
            (totalPrice) => {
              row[self.priceKey] = (totalPrice / val).toFixed(2);
              row.rowSum = (totalPrice / 1).toFixed(2);
              this.dialogLoading = false;
              this.timer = "";
              let numSum = 0;
              let moneySum = 0;
              this.data.forEach((ele) => {
                moneySum += +ele.rowSum;
                numSum += +ele[this.numberKey];
              });
              this.moneySum = moneySum.toFixed(2);
              this.numSum = numSum;
              //
              this.data = Object.assign([], this.data);
            }
          );
        } catch (err) {
          console.log("err==>", err);
          this.dialogLoading = false;
        }
      }, 500);
    },
    inputPriceChange(row) {
      this.removeEmptyRow();
      let val = row[this.priceKey];
      if (!/^[1-9]\d{0,7}(\.\d{1,2})?$|^0\.\d{1,2}$/.test(val)) {
        row.error2 = true;
        row.error2Message = "请输入正确的金额（最多2位小数）";
      } else {
        row.error2 = false;
        row[this.priceKey] = val.slice(0, 9);
      }
      this.calcSums();
    },
    inputPriceBlur() {},
    calcSums() {
      console.log("calcSums start length==>", this.data.length);
      let numSum = 0;
      let moneySum = 0;
      this.data.forEach((ele) => {
        let num = Number(ele[this.numberKey]);
        num = isNaN(num) ? 0 : num;
        let price = Number(ele[this.priceKey]);
        price = isNaN(price) ? 0 : price;
        ele.rowSum = (Math.round(price * 100) * num) / 100;
        moneySum += price * num;
        numSum += num;
      });
      this.moneySum = moneySum.toLocaleString();
      this.numSum = numSum;
      this.data = Object.assign([], this.data);
      this.$emit("update:data", this.data);
    },
    del(row) {
      let index = this.data.indexOf(row);
      this.data.splice(index, 1);
      this.calcSums();
    },
    addOne() {
      if (this.data.find((ele) => ele.inputFlag)) {
        this.$message.error("请先完善上一个货品的信息");
        return;
      }
      this.data.push({ inputFlag: true, consumableId: "" });
    },
    handleSelectChange(val) {
      this.data.pop();
      let rep = this.data.find((ele) => ele.consumableId == val);
      if (rep) {
        this.$refs.table.setCurrentRow(rep);
        this.$message.error("该货品已选择");
      } else {
        let item = this.list.find((ele) => ele.consumableId == val);
        this.data.push(item);
        this.$emit("update:data", this.data);
        this.$emit("afterAdd", [item], this.data);
      }
      this.calcSums();
      this.currentId = "";
      this.list = [];
    },
    //分类树加载
    loadNode(node, resolve) {
      typeLazyTree({
        parentId: node.level === 0 ? 0 : node.data.id,
        projectId: this.projectId,
      }).then((res) => {
        resolve(res.data);
      });
    },
    nodeClick(data) {
      this.query.typeId = data.id;
      this.query.typeName = data.name;
      this.$refs.categoryTree.setCheckedNodes([data]);
      this.$refs.categorySelect.blur();
    },
    addBatch() {
      this.removeEmptyRow();
      this.list = [];
      this.dialogVisible = true;
      this.query = {
        typeName: "",
        typeId: "",
        text: "",
      };
    },
    //多选去重
    selectionChange(val) {
      this.choosenList = this.choosenList.filter(
        (ele) =>
          !this.list.find((ele2) => ele.consumableId == ele2.consumableId)
      );
      this.choosenList.push(...val);
    },
    //多选回显方法
    choosenListReShow() {
      let selectedRows = this.list.filter((ele) =>
        this.choosenList.find((ele2) => ele2.consumableId == ele.consumableId)
      );
      setTimeout(() => {
        this.$refs.crud.toggleSelection(selectedRows);
      });
    },
    crudSubmit() {
      let newAdd = this.choosenList.filter(
        (ele) =>
          !this.data.find((ele2) => ele2.consumableId == ele.consumableId)
      );
      this.data = this.data.concat(newAdd);
      this.$emit("afterAdd", newAdd, this.data);
      this.calcSums();
      this.crudCancel();
    },
    //清空crud数据
    crudCancel() {
      this.$refs.crud.toggleSelection(this.choosenList);
      this.choosenList = [];
      this.dialogVisible = false;
      this.clearSearch();
    },
    //清空search数据
    clearSearch() {
      this.list = [];
      this.query = { text: "", typeId: "", typeName: "" };
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.page.total = 0;
      this.$refs.categoryTree.setCheckedKeys([]);
    },
    search() {
      this.loadData();
    },
    currentChange() {
      this.loadData();
    },
    sizeChange() {
      this.loadData();
    },
    //基础加载数据方法
    loadData(type) {
      this.tableLoading = true;
      if (type == "single") {
        this.query = { text: this.query.text };
      } else {
        this.query.current = this.page.currentPage;
        this.query.pageSize = this.page.pageSize;
      }
      this.$emit("loadData", this.query, (data, column) => {
        data.records.forEach((element) => {
          //处理字典值为字符串,实际值为数字的问题
          element.type = element.type + "";
          //入库特有:历史问题
          if (element.inboundStatus) {
            element.inboundStatus = element.inboundStatus + "";
          }
          //处理后台返回值默认-1的问题
          element[this.numberKey] =
            element[this.numberKey] > 0 ? element[this.numberKey] : 0;
          element[this.priceKey] =
            element[this.priceKey] > 0 ? element[this.priceKey] : 0;
        });
        this.list = data.records;
        this.tableLoading = false;
        if (type != "single") {
          this.page.currentPage = data.current;
          this.page.total = data.total;
          this.page.pageSize = data.pageSize;
          column && (this.option.column = column);
          //多选回显
          this.choosenListReShow();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 10px;
  background-color: #fff;
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
::v-deep .avue-crud__tip {
  display: none;
}
::v-deep .avue-crud__pagination {
  margin-bottom: 10px !important;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}
.add {
  height: 44px;
  line-height: 44px;
  text-align: center;
  border: 1px dashed #333;
  background-color: #fff;
}
//
.crud-submit {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
::v-deep .errorBorder .el-input__inner {
  border: 1px solid #f00;
}
.errorText {
  color: #f00;
  font-size: 12px;
  text-align: left;
}
::v-deep .avue-crud {
  min-height: 420px;
}
</style>